import { Box, Container } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import { Link } from 'react-router-dom';
import {
  KC_NAVIGATOR_PATH,
  KC_TOOLS_PATH,
  getNavigatorLibraryStats,
  listNavigatorObjectives,
  listNavigatorRoles,
} from '../repository';

const RESOURCE_ENTRIES = [
  { label: 'Knowledge centers', to: KC_NAVIGATOR_PATH },
  { label: 'Reference guides', to: '/knowledge-center/guides' },
  { label: 'Templates', to: `${KC_TOOLS_PATH}?resource=templates` },
  { label: 'Calculators', to: `${KC_TOOLS_PATH}?resource=calculators` },
  { label: 'Assessments', to: `${KC_TOOLS_PATH}?resource=assessments` },
];

function BrowsePanel({ index, title, items }) {
  return (
    <section className="kc-nav-panel">
      <div className="kc-nav-entry-head">
        <span className="kc-nav-entry-index">{index}</span>
        <h3 className="kc-nav-entry-title">{title}</h3>
      </div>
      <div className="kc-nav-entry-chips">
        {items.map((item) => (
          <Link key={item.to} to={item.to} className="kc-nav-chip">
            {item.label}
          </Link>
        ))}
      </div>
    </section>
  );
}

export function NavigatorIntroCard() {
  const stats = getNavigatorLibraryStats();
  const roles = listNavigatorRoles();
  const objectives = listNavigatorObjectives();

  const statItems = [
    { value: stats.listed, label: 'resources' },
    { value: stats.centers, label: 'centers' },
    { value: stats.tools, label: 'tools' },
    { value: stats.journeys, label: 'journeys' },
  ];

  return (
    <Box id="kc-navigator" className="kc-navigator-intro w-full py-6 md:py-8 scroll-mt-28">
      <Container maxWidth="lg">
        <div className="kc-navigator-card">
          <div className="kc-navigator-card-glow" aria-hidden />
          <div className="kc-navigator-layout">
            <div className="kc-navigator-copy-col">
              <span className="kc-navigator-badge">
                <ExploreOutlinedIcon sx={{ fontSize: 15 }} />
                Start here
              </span>
              <h2 className="kc-navigator-title">
                <span>Insurance AI Knowledge Center</span>
                <span>Navigator</span>
              </h2>
              <p className="kc-navigator-copy">
                Find the right guidance, implementation center, or practical tool
                based on your role, business objective, insurance function, and
                stage of AI adoption.
              </p>
              <div className="kc-navigator-stat-row" aria-label="Library size">
                {statItems.map((item) => (
                  <div key={item.label} className="kc-navigator-stat-chip">
                    <strong>{item.value}</strong>
                    <span>{item.label}</span>
                  </div>
                ))}
              </div>
              <div className="kc-navigator-actions">
                <Link to={KC_NAVIGATOR_PATH} className="kc-navigator-btn kc-navigator-btn-primary">
                  Explore the Navigator
                  <ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />
                </Link>
                <Link to={KC_TOOLS_PATH} className="kc-navigator-btn kc-navigator-btn-secondary">
                  Browse Downloadable Tools
                  <ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />
                </Link>
              </div>
            </div>

            <div className="kc-navigator-browse">
              <BrowsePanel
                index="01"
                title="By role"
                items={roles.map((role) => ({
                  label: role.label,
                  to: `${KC_NAVIGATOR_PATH}?role=${role.id}`,
                }))}
              />
              <BrowsePanel
                index="02"
                title="By objective"
                items={objectives.map((objective) => ({
                  label: objective.label,
                  to: `${KC_NAVIGATOR_PATH}?journey=${objective.id}`,
                }))}
              />
              <BrowsePanel index="03" title="By resource" items={RESOURCE_ENTRIES} />
            </div>
          </div>
        </div>
      </Container>
    </Box>
  );
}
